export const Hider = ({ hide, children }) => {

    return (
        <div id='vmt-basement' style={hide === false ? { display: 'contents' } : { display: 'none' }}>
            {children}
        </div>
    );
}